import styles from "../Home.module.css";

export default function Report({ title, meta, onClick }) {
  return (
    <div className={styles.reportLink}>
      <h3>
        <a href="#" onClick={(e) => {
          e.preventDefault();
          onClick && onClick();
        }}>
          {title}
        </a>
      </h3>
      <p>{meta}</p>
    </div>
  );
}
